import selectn        from 'selectn'
import dateFormat     from '../dateformat'
import { getCountrySupportedRegion, isEspnCricinfo as isEspnCricinfoSite } from '../common'

// TODO: pull config for other editions
export const configMap = {
  'espn-en-in': 'india',
  'espn-en': 'unitedstates',
  'espn-en-uk': 'unitedkingdom',
  'espn-en-au': 'australia',
  'espn-en-za': 'southafrica',
  'espn-en-ph': 'philippines',
  'espn-en-ww': 'en-global',
  'espnid-en': 'asia',
  'espncricinfo-en-za': 'africa',
  'espncricinfo-en-in': 'india',
  'espncricinfo-en-au': 'australia',
  'espncricinfo-en-bd': 'bangladesh',
  'espncricinfo-en-nz': 'newzealand',
  'espncricinfo-en-pk': 'pakistan',
  'espncricinfo-en-lk': 'srilanka',
  'espncricinfo-en-uk': 'unitedkingdom',
  'espncricinfo-en-us': 'unitedstates',
  'espncricinfo-en-ww': 'global',
  'espn-es-ar': 'spanish/argentina',
  'espn-es-cl': 'spanish/chile',
  'espn-es-co': 'spanish/colombia',
  'espn-es-do': 'spanish/dominicanrepublic',
  'espn-es-ec': 'spanish/ecuador',
  'espn-es-gt': 'spanish/guatemala',
  'espn-es-mx': 'spanish/mexico',
  'espn-es-pa': 'spanish/panama',
  'espn-es-pe': 'spanish/peru',
  'espn-es-es': 'spanish/spain',
  'espn-es-us': 'spanish/unitedstates',
  'espn-es-uy': 'spanish/uruguay',
  'espn-es-ve': 'spanish/venezuela',
  'espn-pt-br': 'portuguese/brazil'
}

export function getheaderSBTopicId(isEspnCricinfo, country, language) {
  let headerKey = country + '-' + language
  if(isEspnCricinfo) {
    headerKey = 'espncricinfo-' + headerKey
  }
  return headerKey
}

export function getEditionKey(request, host = '', lang = 'en', region = 'us', isEspnCricinfo = false) {

  let hostKey
  let environment

  request.query = request.query || {}
  request.headers = request.headers || {}

  if (host) {
    environment = getEnvironment(request)

    if(environment == 'local' || environment == 'ondemand' || environment == 'localdev') {
      const editionSlugMatches = host.match(/^(.*).cloud.go.com(:0-9999+)?/) || []
      if(editionSlugMatches[1]) {
        // host = ##(
        //   'deportes' => 'espndeportes.espn.go.com'
        // )[editionSlugMatches[1]];
      } else if (host == 'coreserver') {
        host = 'espndeportes.espn.go.com'
      } else if (host.indexOf('.sandbox.aws.espn.com') > -1) {
        host = host.replace('.sandbox.aws.espn.com', '')
      } else if(host.indexOf('.sonyespn.com') > -1) {
        host = 'sonyespn.com'
      } else if(host.indexOf('global.espn.com') > -1) {
        host = 'global.espn.com'
      } else if(host.indexOf('tv5.espn.com') > -1) {
        host = 'tv5.espn.com'
      } else if(host.indexOf('espn') > -1) {
        if(host.indexOf('africa') == -1) {
          host = host.replace(/:8080|:1377/, '')
          const espnIndex = host.indexOf('espn')
          host = host.substring(espnIndex)
        }
      } else {
        host = 'espn.com'
      }

    }


    if(isEspnCricinfo) {
      if(typeof region === 'undefined') {
        let country = request.query['country'] || request.headers['x-country'] || ''
        region = getCountrySupportedRegion(country)
      }

      if(typeof region !== 'undefined' && region.length > 0 && region === 'gb') {
        region = 'uk'
      }

      lang = typeof lang !== 'undefined' && lang || 'en'

      hostKey = 'espncricinfo' + '-' + lang + (region.length > 0 ? '-' + region : '')

    } else {
      const hostToSite = {
        // English
        'espn.go.com': 'espn-en',
        'www.espn.com': 'espn-en',
        'espn.co.uk': 'espn-en-uk',
        'espnsb.co.uk': 'espn-en-uk',
        'espnqa.co.uk': 'espn-en-uk',
        'espn.com.au': 'espn-en-au',
        'espnfc.com': 'espnfc-en',
        'espnfc.us': 'espnfc-en-us',
        'espnfc.co.uk': 'espnfc-en-uk',
        'espnfc.com.ng': 'espnfc-en-ng',
        'espnfc.com.au': 'espnfc-en-au',
        'espnfcasia.com': 'espnfc-en-sg',
        'espn.in': 'espn-en-in',
        'espnsb.in': 'espn-en-in',
        'sonyespn.com': 'espn-en-in',
        'xgames.espn.go.com': 'xgames',
        'africa.espn.com': 'espnza-en',
        'africa.espnsb.com': 'espnza-en',
        'tv5.espn.com': 'espnph-en',
        'global.espn.com': 'espn-en-ww',
        'asia.espn.com': 'espnid-en',
        // Spanish
        'espndeportes.espn.go.com': 'espn-es-us',
        'espndeportes.espn.com': 'espn-es-us',
        'espndeportes.com': 'espn-es-us',
        'espn.com.ar': 'espn-es-ar',
        'espn.com.co': 'espn-es-co',
        'espn.com.mx': 'espn-es-mx',
        'espn.com.ve': 'espn-es-ve',
        'espn.cl': 'espn-es-cl',
        'espn.es': 'espn-es-es',
        // Portuguese
        'espn.uol.com.br': 'espn-pt-br',
        'espn.com.br': 'espn-pt-br'
      }

      hostKey = hostToSite[host]
    }


  } else if (lang && region) {
    hostKey = 'espn'

    if (lang === 'es') {
      hostKey = hostKey + '-' + lang + '-' +  region
    // the english team came up with a different key schema
    } else if (lang === 'en') {
      if (region === 'gb') {
        region = 'uk'
      }
      if (region !== 'us') {
        hostKey = hostKey + region
      }
      hostKey = hostKey + '-' + lang
    }
  }

  if(!hostKey) { //if unknown host like local or iaas, then use espn-en
    hostKey = isEspnCricinfo ? 'espncricinfo-en-ww' : 'espn-en'
  }

  return hostKey
}

export function getEnvironment(request) {

  let environment = ''

  // determine environment from host
  const host = selectn('headers.host', request) || ''

  if (host.startsWith('espn') || host.startsWith('n7') || host.startsWith('proxy') || host.startsWith('sports') || host.startsWith('scores')) {
    environment = 'prod'
  } else if(host.startsWith('prod-preview')) {
    environment = 'prod-preview'
  } else if(host.startsWith('prod-mast')) {
    environment = 'prod-mast'
  } else if (host.startsWith('dev') || host.startsWith('test') || host.startsWith('vwtsas') || host.startsWith('vwdsapp')) {
    environment = 'dev'
  } else if (host.startsWith('beta.qa.') || host.startsWith('beta.qa2.') || host.startsWith('qa') || host.startsWith('qn7espn')) {
    environment = 'qa'
  } else if (host.indexOf('espnqa') !== -1) {
    environment = 'qa'
  } else {
    environment = 'local'
  }

  environment = environment.toLowerCase().trim()

  // normalize qa2 -> qa
  if(environment == 'qa2') {
    environment = 'qa'
  }else if(environment == 'maven' || environment == 'localdev' || environment == 'dev') {
    environment = 'local'
  }else if (environment == 'prod_preview') {
    environment = 'prod-preview'
  }else if (environment == 'prod_mast') {
    environment = 'prod-mast'
  }

  return environment

}

export function getEditionSettings(request = {}) {

  request.query = request.query || {}
  request.headers = request.headers || {}
  let editionConfig = {}
  const asiaRegions = [ 'in', 'pk', 'lk', 'bd' ]
  let isAsiaRegion = false

  let host = request.query['host'] || request.headers['host'] || request.headers['Host'] || request.hostname
  const editionHostParam = request.query['edition-host']
  let localEditionKey = request.query['edition'] || request.headers['x-edition'] || ''
  let edition_view = request.query['edition-view'] || request.headers['x-edition-view'] || ''
  let lang = request.query['lang'] || 'en'
  let region = request.query['region'] || 'us'

  if(editionHostParam) {
    host = editionHostParam
  }

  const hostReplaces = /localhost|local\.|127.0.0.1\.|www\.|-qa|qa\.|preview\./

  if (typeof host === 'string') {
    // replace espnqa.com with espn.com
    host = host.replace('espnqa.com', 'espn.com')

    host = host.replace(hostReplaces, '')
  }

  /* NOTE: webpack will load everyone of these config files so uk will get anz, in, us config to download needs consideration as we add more
   * https://github.com/webpack/webpack/issues/118
  */

  const isEspnCricinfo = isEspnCricinfoSite(host, localEditionKey)

  if(isEspnCricinfo) {
    edition_view = edition_view ? edition_view : 'espncricinfo-en-ww'
    let edition_country = ''
    let editionViewArr = edition_view.split('-')
    if(editionViewArr.length > 0) {
      edition_country = editionViewArr[2]
    }
    host = 'cricinfo.com'
    region = getCountrySupportedRegion(edition_country)
  }

  let userGeo = request.query['locale'] || request.query['country'] || request.headers['x-country']  || 'us'
  userGeo = userGeo.toLowerCase()

  if (userGeo === 'uk') {
    userGeo = 'gb'
  }

  const editionKey = getEditionKey(request, host, lang, region, isEspnCricinfo)

  if(isEspnCricinfo) {
    editionConfig = require('./config/cricinfo/' + (configMap[editionKey] || configMap['espncricinfo-en-ww'])).default
  }else if(edition_view) {
    editionConfig = require('./config/' + (configMap[edition_view] || configMap['espn-en'])).default
  }else if(lang === 'en' || lang === 'es' || lang === 'pt') {
    editionConfig = require('./config/' + (configMap[editionKey] || configMap['espn-en'])).default
  }

  const editionSettings = editionConfig.editionSettings || {}
  const site = editionSettings.site
  const timeZoneBucket = selectn('dateTime.timeZoneBucket', editionConfig) || 'America/New_York'
  const language = editionSettings.language
  const country = editionSettings.country
  const countryName = editionSettings.countryName
  const domain = editionSettings.domain
  const siteId = editionSettings.editionSiteId
  const https = editionSettings.https
  const reactOverride = editionConfig.reactOverride || {}
  const sponsoredContentProviders = editionConfig.sponsoredContentProviders || []
  const taboolaSettings = editionConfig.taboola || {}
  const outbrainSettings = editionConfig.outbrain || {}
  const isMultiSports = isEspnCricinfo ? false : true
  const defaultSport = isEspnCricinfo ? 'cricket' : ''
  const uriRewrites = selectn('uriRewrites', editionConfig)
  const editionDateFormat = selectn('dateTime', editionConfig)
  const fallback = selectn('fallback',editionConfig)

  const gameSettings = editionConfig.gameSettings || {}
  const topEventsId = gameSettings.topEventsId


  const geoCountry = userGeo ? userGeo : country

  if( isEspnCricinfo && asiaRegions.indexOf(geoCountry.toLowerCase()) > -1 ) {
    isAsiaRegion = true
  }

  host = host || domain.replace(hostReplaces, '')
  const headerSBTopicId = getheaderSBTopicId(isEspnCricinfo, country, language)

  // use edition config rather than header/params
  localEditionKey = edition_view = editionSettings.key

  const edition = {
    country: country,
    userGeo: userGeo,
    isAsiaRegion: isAsiaRegion,
    countryName: countryName,
    language: language,
    domain : domain,
    site : site,
    // config: editionConfig,
    siteId : siteId,
    timeZoneBucket: dateFormat.getTimezone( timeZoneBucket ),
    timeZoneDomain: timeZoneBucket,
    editionKey: editionKey,
    localEditionKey: localEditionKey,
    xEdition: localEditionKey,
    xEditionView: edition_view,
    host : host,
    // rewrites : rewrites,
    https : https,
    uriRewrites : uriRewrites,
    // configs : configs
    reactOverride : reactOverride,
    taboola: taboolaSettings,
    outbrain: outbrainSettings,
    sponsoredContentProviders: sponsoredContentProviders,
    isEspnCricinfo : isEspnCricinfo,
    isMultiSports : isMultiSports,
    defaultSport : defaultSport,
    topEventsId : topEventsId,
    headerSBTopicId,
    editionDateFormat : editionDateFormat,
    fallback : fallback,
    analytics: editionConfig.analytics
  }

  return edition

}



// WEBPACK FOOTER //
// ../app/lib/utils/editions/index.js